import React from "react";

import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {OptionButton} from "../../../../designSystem/components/OptionButton";

type GuestSelectorPanelProps = {
  search: string;
  onChangeSearch: (value: string) => void;
  filteredGuests: any[];
  selectedGuestId: string;
  onSelectGuest: (lineUserId: string, name: string) => void;
};

export const GuestSelectorPanel = ({
  search,
  onChangeSearch,
  filteredGuests,
  selectedGuestId,
  onSelectGuest,
}: GuestSelectorPanelProps) => (
  <div className="min-w-[200px] max-w-[200px] h-full flex flex-col gap-4">
    <div>
      <BaseInput
        placeholder="搜尋姓名"
        value={search}
        onChange={(e) => onChangeSearch(e.target.value)}
      />
    </div>

    <div className="flex flex-1 flex-col gap-2 overflow-y-auto p-2">
      {filteredGuests.map((guest) => (
        <OptionButton
          key={guest.id}
          label={guest.name}
          isSelected={selectedGuestId === guest.lineUserId}
          onClick={() => onSelectGuest(guest.lineUserId, guest.name)}
        />
      ))}
    </div>
  </div>
);
